import { render, staticRenderFns } from "./rgtpSet.vue?vue&type=template&id=912a8ebc&scoped=true&"
import script from "./rgtpSet.vue?vue&type=script&lang=js&"
export * from "./rgtpSet.vue?vue&type=script&lang=js&"
import style0 from "./rgtpSet.vue?vue&type=style&index=0&id=912a8ebc&prod&lang=scss&scoped=true&"
import style1 from "./rgtpSet.vue?vue&type=style&index=1&id=912a8ebc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912a8ebc",
  null
  
)

export default component.exports